import { AGG } from './types';

export const linkedinCampaigns = {
  id: 'linkedin-campaigns',
  label: 'Campagne LinkedIn',
  description: 'Report dedicato a campagne LinkedIn. Include audience per Settore e Qualifica.',
  single_image: true,
  sections: [
    {
      id: 'linkedin',
      title: 'LinkedIn',
      blocks: [
        {
          channel: 'linkedin',
          kpis: [
            { key: 'date_start',            label: 'Data di inizio',              aggregation: AGG.AUTO_MIN },
            { key: 'date_end',              label: 'Data di fine',                aggregation: AGG.AUTO_MAX },
            { key: 'spend',                 label: 'Importo speso',               aggregation: AGG.SUM, unit: 'currency' },
            { key: 'impressions',           label: 'Impression',                  aggregation: AGG.SUM, note: 'Si sommate' },
            { key: 'cpm',                   label: 'CPM',                         aggregation: AGG.SUM, unit: 'currency', note: 'Si sommate' },
            { key: 'link_clicks',           label: 'Click',                       aggregation: AGG.SUM, note: 'Tutti' },
            { key: 'cpc',                   label: 'CPC',                         aggregation: AGG.SUM, unit: 'currency', note: 'Tutti' },
            { key: 'ctr',                   label: 'CTR',                         aggregation: AGG.SUM, unit: 'percent' },
            { key: 'engagement',            label: 'Engagement',                  aggregation: AGG.SUM },
            { key: 'reactions',             label: 'Reazioni',                    aggregation: AGG.SUM },
            { key: 'linkedin_apply_clicks', label: 'Click su pulsante candidati', aggregation: AGG.SUM },
            { key: 'linkedin_segments',     label: 'Segmenti',                    aggregation: AGG.SUM },
            { key: 'linkedin_audience',     label: 'Audience',                    aggregation: AGG.SUM, note: 'Settore e Qualifica' },
          ],
        },
      ],
    },
  ],
};
